<app-main-pages-container>
            <section>
                <p>
                    {{ 'to_contact_the_administration_write_to_email' | translate }}
                    <a href="mailto:{{'current_email' | translate}}">{{ 'current_email' | translate }}</a>
                </p>
            </section>

            <button mat-flat-button routerLink="">{{ 'home' | translate }}</button>
</app-main-pages-container>